// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconInputCheck = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9">
            <polygon
                fill="currentColor"
                points="27.5 .797 27.102 1.195 21.16 7.106 20.764 7.502 20.368 7.106 17.398 4.151 17 3.755 17.795 2.958 18.193 3.354 20.764 5.913 26.307 .396 26.705 0 27.5 .797"
                transform="translate(-17 .75)"
            />
        </svg>
    );
};

export default React.memo(IconInputCheck);
